export const BUSINESS_TIMEZONES = [
	"",
	"UTC",
	"America/Sao_Paulo",
	"America/Manaus",
	"America/Rio_Branco",
	"America/Noronha",
	"America/New_York",
	"America/Chicago",
	"America/Denver",
	"America/Los_Angeles",
	"America/Mexico_City",
	"America/Argentina/Buenos_Aires",
	"America/Santiago",
	"Europe/London",
	"Europe/Lisbon",
	"Europe/Madrid",
	"Europe/Paris",
	"Africa/Luanda",
	"Asia/Tokyo"
];

export function getAllSupportedTimezonesList() {
	return BUSINESS_TIMEZONES;
}
